module.exports = __webpack_public_path__ + "img/computer-screenNEW.d2cffa78.png";